import React from 'react'

const NewEvents = () => {
  return (
    <><h2>New events</h2><h3>Refresh me, and you will still be on this page.</h3></>
  )
}

export default NewEvents